import Layout from '@/layout/index';
const router = [
  {
    path: '/data',
    component: Layout,
    redirect: '/data/info',
    meta: {
      auth_key: 'view_report',
      child_auth_key: 'permission_data',
      auth: true,
      title: '活动数据',
      name: 'dataMgr',
      icon: 'saasicon_charts_img'
    },
    children: [
      {
        path: 'info',
        component: () => import('@/views/StatisticsModule/dataInfo'),
        meta: {
          auth_key: 'view_report', child_auth_key: 'permission_data', title: '数据总览', name: 'dataInfo'
        }
      },
      {
        path: 'live',
        component: () => import('@/views/StatisticsModule/dataLive'),
        meta: {
          auth_key: 'view_report', child_auth_key: 'permission_data', title: '活动数据', name: 'dataLive'
        }
      }
    ]
  }
];
export default router;
